const spanish = {
    errors: {
        global: {
            login_failed: 'Falló el intento de inicio de sesión.',
            account_not_activated: 'La cuenta no se ha  activado',
            temporarily_locked_account: 'La cuenta se bloqueó temporalmente por intentos fallidos de acceso, intentelo nuevamente después de LOCK_TIMEOUT minutos o cambie la contraseña',
            account_disabled: 'La cuenta está desactivada',
            internal_server_error: 'Error Interno del Servidor',
            username_or_email_or_cell_phone_is_requiered: 'Debe ingresarse un username o un email o un celular',
            account_does_not_exist: 'La cuenta no existe'
        }
    },
    texts: {
        pages: {
            signin: {
                log_in: 'Iniciar Sesión',
                recover_password: 'Recuperar contraseña',
                session_failed: 'No se pudo iniciar sesión',
                username: 'Nombre de Usuario',
                password: 'Contraseña',
            }
        },
        components: {

        }
    }
}

export default spanish;